import { formatDistanceToNow } from 'date-fns'
import pluralize from 'pluralize'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { type SequenceTemplate } from '@/models/sequenceTemplate'

interface SequenceTemplateListItemProps {
  template: SequenceTemplate
  selected: boolean
  onSelect: () => void
}

export function SequenceTemplateListItem({ template, selected, onSelect }: SequenceTemplateListItemProps) {
  const updated = template.updatedAt
    ? formatDistanceToNow(new Date(template.updatedAt), { addSuffix: true })
    : null

  return (
    <Button
      variant="outlineThin"
      onClick={onSelect}
      aria-current={selected || undefined}
      className={cn(
        'h-auto w-full flex-col items-stretch gap-0.5 px-3 py-2 text-left font-normal whitespace-normal',
        selected && 'border-blue-500 bg-blue-50 hover:bg-blue-50'
      )}
    >
      <span className="truncate font-medium">{template.name || 'Untitled'}</span>
      <span className="text-muted-foreground text-xs">
        {pluralize('step', template.steps.length, true)}
        {updated && <> · Updated {updated}</>}
      </span>
    </Button>
  )
}
